import React from 'react';
import { number, object, string } from 'prop-types';
import { N400 } from '@assets/colors';

const SearchIcon = ({ className, color, size, style }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={style}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333C10.7073 15.8333 12.1258 15.3108 13.2547 14.4332L16.0774 17.2559C16.4028 17.5814 16.9305 17.5814 17.2559 17.2559C17.5814 16.9305 17.5814 16.4028 17.2559 16.0774L14.4332 13.2547C15.3108 12.1258 15.8333 10.7073 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5ZM4.16667 9.16667C4.16667 6.40524 6.40524 4.16667 9.16667 4.16667C11.9281 4.16667 14.1667 6.40524 14.1667 9.16667C14.1667 11.9281 11.9281 14.1667 9.16667 14.1667C6.40524 14.1667 4.16667 11.9281 4.16667 9.16667Z"
      fill={color}
    />
  </svg>
);

SearchIcon.propTypes = {
  className: string,
  color: string,
  size: number,
  style: object,
};

SearchIcon.defaultProps = {
  className: '',
  color: N400,
  size: 20,
  style: {},
};

export default SearchIcon;
